"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      addForm: {
        groupName: "",
        formName: "",
        formContent: "",
        endTime: "",
        startTime: "",
        matchId: this.$route.query.matchId,
        manageStartTime: "",
        manageEndTime: "",
        id: this.$route.query.id
      },
      isNeedForm: false,
      rules: {
        groupName: [{
          required: true,
          message: "请填写组别名称",
          trigger: "blur"
        }],
        formName: [{
          required: true,
          message: "请填写报名表名称",
          trigger: "blur"
        }],
        startTime: [{
          required: true,
          message: "请填写报名表开始时间",
          trigger: "blur"
        }],
        endTime: [{
          required: true,
          message: "请填写报名表结束时间",
          trigger: "blur"
        }],
        manageStartTime: [{
          required: true,
          message: "请填写报名表审核开始时间",
          trigger: "blur"
        }],
        manageEndTime: [{
          required: true,
          message: "请填写报名表审核结束时间",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    // 提交
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _project.groupEdit)(_this.addForm).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("操作成功。");
              history.go(-1);
            }
          });
        }
      });
    },
    // 返回
    isBack: function isBack() {
      // this.$router.push("/object/object");
      history.go(-1);
    }
  },
  created: function created() {
    var _this2 = this;
    // 根据项目id回显数据
    (0, _project.backView)({
      id: this.$route.query.matchId
    }).then(function (res) {
      var data = res.data;
      if (data.isNeedForm == 1) {
        _this2.isNeedForm = true;
      } else {
        _this2.isNeedForm = false;
      }
    });
    this.addForm = this.$route.query;
  }
};